import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BodyTypeFilterResultCounts, FilterOption } from '../../../types';
import { FilterTypes } from '../../../constants/initialFilters';
import { COLORS } from '../../../styles/variables';
import CheckMarkIcon from '../../../assets/icons/CheckMarkIcon';
import { BodyButton } from './bodyStyle.style';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

type BodyType = keyof BodyTypeFilterResultCounts;
interface BodyTypes {
  body: AvailableFiltersCount;
  filterType: string;
  confirmedFilters: FilterTypes;
  handleAddFilter: (filterType: string, value: string, isChecked?: boolean) => void;
}

const Body: React.FC<BodyTypes> = ({ body, filterType, confirmedFilters, handleAddFilter }) => {
  const { t, i18n } = useTranslation();
  const { value } = body;

  const isSelected = confirmedFilters.bodyType.includes(value);
  const label = t(`vlp.filters.filterOptions.bodyType.${value}`);

  const isAvailable = !body.disabled;
  return (
    <BodyButton
      type="button"
      key={value}
      disabled={!isAvailable}
      onClick={() => handleAddFilter(filterType, value, isSelected)}
      data-testid={`bodyStyle-${value}`}
      data-cy="bodyStyle-button"
      isSelected={isSelected}
      isAvailable={isAvailable}
    >
      {isSelected && <CheckMarkIcon size={24} />}
      {label}
    </BodyButton>
  );
};

export default Body;
